import { render, staticRenderFns } from "./UploadProductFilesModal.vue?vue&type=template&id=154f3141&scoped=true"
import script from "./UploadProductFilesModal.vue?vue&type=script&lang=js"
export * from "./UploadProductFilesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f3141",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154f3141')) {
      api.createRecord('154f3141', component.options)
    } else {
      api.reload('154f3141', component.options)
    }
    module.hot.accept("./UploadProductFilesModal.vue?vue&type=template&id=154f3141&scoped=true", function () {
      api.rerender('154f3141', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/UploadProductFilesModal.vue"
export default component.exports